export default {
  initialModal: {
    title: 'Welcome to Prodgy! 🎉',
    description: 'We would like to guide you through the main features of the platform. This tour will only take a few minutes.',
    benefits: 'By completing this tour you will:',
    benefit1: 'Create your first workspace',
    benefit2: 'Set up your Brain',
    benefit3: 'Connect tools and install flows',
    benefit4: 'Test your agents in the playground',
    start: 'Start Tour',
    skip: 'Skip',
    alreadyCompleted: 'You have already completed this tour!'
  },
  completionModal: {
    title: 'Congratulations! 🎊',
    description: 'You have successfully completed the guided tour!',
    message: 'Now it\'s up to you!',
    helpText: 'You can restart this tour anytime through the user menu.',
    close: 'Continue using...'
  },
  closeConfirmation: {
    title: 'Do you really want to exit the tour?',
    message: 'You will lose your current progress in the guided tour. You can restart it at any time through the help menu.',
    confirm: 'Yes, exit tour',
    cancel: 'Continue tour'
  },
  checklist: {
    title: 'Guided Tour'
  },
  navbar: {
    restart: 'Restart Tour'
  },
  reminder: {
    title: 'I\'m here whenever you need me!',
    message: 'You can resume the tour anytime through the help button in the top bar.'
  }
};
